import * as Colors from '@wandb/weave/common/css/color.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const SecretNameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
SecretNameCell.displayName = 'S.SecretNameCell';

export const SecretName = styled.div`
  max-width: 240px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
SecretName.displayName = 'S.SecretName';

export const SecretOptions = styled.div`
  display: flex;
  gap: 16px;
  float: right;
  align-items: center;
`;
SecretOptions.displayName = 'S.SecretOptions';

export const UpdatedDateText = styled.div`
  color: ${Colors.MOON_600};
  margin-right: 8px;
`;
UpdatedDateText.displayName = 'S.UpdatedDateText';

export const SecretsSummary = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0px;
`;
SecretsSummary.displayName = 'S.SecretsSummary';
